import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "insure__body"
};
import { track } from "@/analytics/events";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
export default {
  __name: 'cardsInsured',
  setup(__props) {
    const trackSegment = event => {
      track(`Static Clickable`, {
        source: `${event}`
      });
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_link, {
        to: "/travel-protection-insurance",
        onClick: _cache[0] || (_cache[0] = $event => trackSegment('Learn more - Travel Protection Insurance'))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("div", {
          class: "insure__card"
        }, [_createElementVNode("div", {
          class: "insure__imagebox"
        }, [_createElementVNode("img", {
          src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/insurance-types/protect.png",
          alt: "Illustration of a traveler meditating peacefully, knowing their trip is protected"
        })]), _createElementVNode("div", {
          class: "insure__footer"
        }, [_createElementVNode("h5", null, [_createTextVNode(" Travel Protection "), _createElementVNode("br"), _createTextVNode(" Insurance ")]), _createElementVNode("div", {
          class: "learn-btn"
        }, [_createElementVNode("span", {
          class: "primary__link"
        }, "Learn more")])])], -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/usa-visitor-health-insurance",
        onClick: _cache[1] || (_cache[1] = $event => trackSegment('Learn more - USA Visitor Health Insurance'))
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("div", {
          class: "insure__card"
        }, [_createElementVNode("div", {
          class: "insure__imagebox"
        }, [_createElementVNode("img", {
          src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/insurance-types/visitor.png",
          alt: "Illustration of a mother with a suitcase reaching out to hug her son"
        })]), _createElementVNode("div", {
          class: "insure__footer"
        }, [_createElementVNode("h5", null, [_createTextVNode(" USA Visitor "), _createElementVNode("br"), _createTextVNode(" Health Insurance ")]), _createElementVNode("div", {
          class: "learn-btn"
        }, [_createElementVNode("span", {
          class: "primary__link"
        }, "Learn more")])])], -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/travel-medical-insurance",
        onClick: _cache[2] || (_cache[2] = $event => trackSegment('Learn more - Travel Medical Insurance'))
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("div", {
          class: "insure__card"
        }, [_createElementVNode("div", {
          class: "insure__imagebox"
        }, [_createElementVNode("img", {
          src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/insurance-types/medical.png",
          alt: "Illustration of a woman speaking to a healthcare professional on her mobile phone"
        })]), _createElementVNode("div", {
          class: "insure__footer"
        }, [_createElementVNode("h5", null, [_createTextVNode(" Travel Medical "), _createElementVNode("br"), _createTextVNode(" Insurance ")]), _createElementVNode("div", {
          class: "learn-btn"
        }, [_createElementVNode("span", {
          class: "primary__link"
        }, "Learn more")])])], -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/trip-cancellation-for-any-reason",
        onClick: _cache[3] || (_cache[3] = $event => trackSegment('Learn more - Cancel for Any Reason Insurance'))
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("div", {
          class: "insure__card"
        }, [_createElementVNode("div", {
          class: "insure__imagebox"
        }, [_createElementVNode("img", {
          src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/insurance-types/cancel.png",
          alt: "Illustration of a plane ticket and a button labeled 'cancel trip'"
        })]), _createElementVNode("div", {
          class: "insure__footer"
        }, [_createElementVNode("h5", null, [_createTextVNode(" Cancel for Any Reason "), _createElementVNode("br"), _createTextVNode(" Insurance ")]), _createElementVNode("div", {
          class: "learn-btn"
        }, [_createElementVNode("span", {
          class: "primary__link"
        }, "Learn more")])])], -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/adventure-travel-sports-insurance",
        onClick: _cache[4] || (_cache[4] = $event => trackSegment('Learn more - Adventure Sports Travel Insurance'))
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createElementVNode("div", {
          class: "insure__card"
        }, [_createElementVNode("div", {
          class: "insure__imagebox"
        }, [_createElementVNode("img", {
          src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/insurance-types/adventure.png",
          alt: "Illustration of a woman surfing on a travel sports adventure"
        })]), _createElementVNode("div", {
          class: "insure__footer"
        }, [_createElementVNode("h5", null, [_createTextVNode(" Adventure Sports "), _createElementVNode("br"), _createTextVNode(" Travel Insurance ")]), _createElementVNode("div", {
          class: "learn-btn"
        }, [_createElementVNode("span", {
          class: "primary__link"
        }, "Learn more")])])], -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/nomad-insurance",
        onClick: _cache[5] || (_cache[5] = $event => trackSegment('Learn more - Nomad Insurance'))
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("div", {
          class: "insure__card"
        }, [_createElementVNode("div", {
          class: "insure__imagebox"
        }, [_createElementVNode("img", {
          src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/insurance-types/nomad.png",
          alt: "Illustration of a travel nomad working from their laptop while on the beach"
        })]), _createElementVNode("div", {
          class: "insure__footer"
        }, [_createElementVNode("h5", null, [_createTextVNode(" Nomad "), _createElementVNode("br"), _createTextVNode(" Insurance ")]), _createElementVNode("div", {
          class: "learn-btn"
        }, [_createElementVNode("span", {
          class: "primary__link"
        }, "Learn more")])])], -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/emergency-medical-evacuation-insurance",
        onClick: _cache[6] || (_cache[6] = $event => trackSegment('Learn more - Medical Evacuation'))
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createElementVNode("div", {
          class: "insure__card"
        }, [_createElementVNode("div", {
          class: "insure__imagebox"
        }, [_createElementVNode("img", {
          src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/insurance-types/evacuation.png",
          alt: "Illustration of a medical rescue evacuation helicopter"
        })]), _createElementVNode("div", {
          class: "insure__footer"
        }, [_createElementVNode("h5", null, [_createTextVNode(" Medical "), _createElementVNode("br"), _createTextVNode(" Evacuation ")]), _createElementVNode("div", {
          class: "learn-btn"
        }, [_createElementVNode("span", {
          class: "primary__link"
        }, "Learn more")])])], -1)])),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/student-medical-insurance",
        onClick: _cache[7] || (_cache[7] = $event => trackSegment('Learn more - Student Medical Insurance'))
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("div", {
          class: "insure__card"
        }, [_createElementVNode("div", {
          class: "insure__imagebox"
        }, [_createElementVNode("img", {
          src: "https://g1gv3.s3.us-west-1.amazonaws.com/frontend-assets/insurance-types/student.png",
          alt: "Illustration of a student taking notes with a book and laptop"
        })]), _createElementVNode("div", {
          class: "insure__footer"
        }, [_createElementVNode("h5", null, [_createTextVNode(" Student Medical "), _createElementVNode("br"), _createTextVNode(" Insurance ")]), _createElementVNode("div", {
          class: "learn-btn"
        }, [_createElementVNode("span", {
          class: "primary__link"
        }, "Learn more")])])], -1)])),
        _: 1
      })]);
    };
  }
};